import { Box, Checkbox, InputBase, Stack, Typography, styled } from '@mui/material'
import { IMooringType, IPositionType } from '../../../generated-types'
import { useTranslation } from 'react-i18next'
import { MdSearch } from 'react-icons/md'
import React from 'react'
import { getThemeColor } from 'src/utils'
import { MUIThemeColors } from 'src/mui-theme'
interface PositionTableFilterProps {
  filteredTypes: IPositionType[]
  mooringType?: IMooringType
  setFilteredTypes: React.Dispatch<React.SetStateAction<IPositionType[]>>
  searchInput?: string
  setSearchInput: React.Dispatch<React.SetStateAction<string>>
}

export const PositionTableFilter: React.FC<PositionTableFilterProps> = ({
  setFilteredTypes,
  filteredTypes,
  mooringType,
  setSearchInput,
  searchInput,
}) => {
  const { t } = useTranslation(['position', 'common'])

  const positionTypesArray: IPositionType[] = [
    IPositionType.MooringLine,
    IPositionType.Corner,
    IPositionType.Bridle,
    IPositionType.FrameLines,
  ]

  const handleCheckboxChange = type => {
    if (type == 'all' && filteredTypes.length != positionTypesArray.length) {
      setFilteredTypes(positionTypesArray)
    } else {
      if (type == 'all' && filteredTypes.length == positionTypesArray.length) {
        setFilteredTypes([])
        return
      }
      if (filteredTypes.includes(type)) {
        setFilteredTypes(filteredTypes.filter(t => t !== type))
      } else {
        setFilteredTypes([...filteredTypes, type])
      }
    }
  }

  const onSearchInputChange = input => {
    setSearchInput(input)
  }

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" width="100%" gap={2}>
      <Stack direction="row" justifyContent="flex-start" alignItems="center">
        <Checkbox
          checked={filteredTypes.length === positionTypesArray.length}
          onChange={() => handleCheckboxChange('all')}
        />
        <CheckboxTypography onClick={() => handleCheckboxChange('all')}>
          {t('all', { ns: 'common' })}
        </CheckboxTypography>
        {positionTypesArray?.map(type => (
          <Stack key={type} direction="row" justifyContent="flex-start" alignItems="center">
            <Checkbox checked={filteredTypes.includes(type)} onChange={() => handleCheckboxChange(type)} />
            <CheckboxTypography onClick={() => handleCheckboxChange(type)}>
              {t(IPositionType[type], { ns: 'position' })}
            </CheckboxTypography>
          </Stack>
        ))}
      </Stack>
      <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
        <SearchBar
          searchInput={searchInput}
          placeholder={t('search', { ns: 'common' })}
          onChange={onSearchInputChange}
          width="100%"
        />
      </Box>
    </Stack>
  )
}

interface SearchBarProps {
  searchInput?: any
  placeholder?: any
  onChange?: any
  width?: any
}
export const SearchBar: React.FC<SearchBarProps> = ({ searchInput, placeholder, onChange, width }) => {
  return (
    <StyledSearchBarBox>
      <InputBase
        sx={{ borderColor: 'white', padding: '4px 16px', width: '100%' }}
        autoFocus={searchInput != '' ? true : false}
        placeholder={placeholder}
        inputProps={{ 'aria-label': 'search' }}
        defaultValue={searchInput}
        onChange={event => onChange(event.target.value)}
      />
      <Box sx={{ mt: '8px', mr: '8px' }}>
        <MdSearch color="black" size={20} />
      </Box>
    </StyledSearchBarBox>
  )
}

const StyledSearchBarBox = styled(Box)(({ theme }) => ({
  borderRadius: 4,
  border: `1px solid ${getThemeColor(theme, MUIThemeColors.primaryDark)}1F`,
  minWidth: '100%',
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  marginBottom: '5px',
}))

const CheckboxTypography = styled(Typography)(({ theme }) => ({
  color: getThemeColor(theme, MUIThemeColors.primaryDark),
  fontVariant: 'subtitle2',
  paddingTop: 2,
  marginRight: 12,
  cursor: 'pointer',
}))
